import { Typography, Box, Grid, Card, CardContent, Container } from '@mui/material';
import SEO from 'features/shared/components/common/SEO';
import { pageSEO } from 'config/seo';
import { motion } from 'framer-motion';

export default function Nosotros(){
  return (
    <>
      <SEO 
        title={pageSEO.nosotros.title}
        description={pageSEO.nosotros.description}
      />

      <Container maxWidth="lg" sx={{ my: { xs: 6, md: 10 } }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Typography variant="h3" sx={{ mb: 6, fontWeight: 800, fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
            Sobre <span className="text-gradient">Nosotros</span>
          </Typography>
        </motion.div>

        <Grid container spacing={6}>
          <Grid item xs={12} md={8}>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <Typography variant="h4" sx={{ mb: 3, fontWeight: 700, color: '#F8FAFC' }}>
                Innovación en movimiento
              </Typography>
              <Typography paragraph sx={{ color: 'text.secondary', fontSize: '1.1rem', lineHeight: 1.8 }}>
                En Rolsys Solutions brindamos asesoría en TI y soporte especializado con enfoque 
                humano y resultados medibles. Nos especializamos en ayudar a empresas a optimizar 
                su operación tecnológica mediante decisiones informadas y soporte técnico de calidad.
              </Typography>
              <Typography paragraph sx={{ color: 'text.secondary', fontSize: '1.1rem', lineHeight: 1.8 }}>
                Nuestro equipo combina experiencia técnica con un profundo entendimiento de las 
                necesidades empresariales, ofreciendo soluciones que van desde asesoría estratégica 
                hasta soporte técnico especializado.
              </Typography>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={4}>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <Card 
                elevation={0} 
                sx={{ 
                  background: 'var(--glass-bg)',
                  backdropFilter: 'blur(12px)',
                  border: '1px solid var(--glass-border)',
                  borderRadius: '20px'
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 700, mt: 1, color: '#F8FAFC' }}>
                    Nuestra Cobertura
                  </Typography>
                  
                  <Box sx={{ mb: 2, p: 2, background: 'rgba(255,255,255,0.03)', borderRadius: '12px' }}>
                    <Typography variant="body2" sx={{ color: '#60A5FA', mb: 0.5, fontWeight: 600 }}>Nacional</Typography>
                    <Typography variant="body1" sx={{ color: '#F8FAFC' }}>Asesoría en TI</Typography>
                  </Box>

                  <Box sx={{ mb: 2, p: 2, background: 'rgba(255,255,255,0.03)', borderRadius: '12px' }}>
                    <Typography variant="body2" sx={{ color: '#A78BFA', mb: 0.5, fontWeight: 600 }}>Todo México</Typography>
                    <Typography variant="body1" sx={{ color: '#F8FAFC' }}>Soporte Remoto</Typography>
                  </Box>

                  <Box sx={{ p: 2, background: 'rgba(255,255,255,0.03)', borderRadius: '12px' }}>
                    <Typography variant="body2" sx={{ color: '#34D399', mb: 0.5, fontWeight: 600 }}>Ciudad de México</Typography>
                    <Typography variant="body1" sx={{ color: '#F8FAFC' }}>Soporte en Sitio</Typography>
                  </Box>
                  
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}